// Format numeric IDs with prefixes
export const formatCustomerId = (num) => num ? `U-${num}` : '—';
export const formatServerId = (num) => num ? `S-${num}` : '—';
